import { defineElement, html, TemplateElement, when } from '@webtides/element-js';
import '../../../../src/components/@e-banking/components/e-banking-tab-item/e-banking-tab-item.js';

class EditableTabItem extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }

    injectProperties() {
        return { mgnlContext: null };
    }

    template() {
        return html`
            ${when(
                !this.mgnlContext?.isMagnoliaEdit,
                html`
                    <mb-e-banking-tab-item title="${this.content.title}" name="${this.content.name}">
                        <mgnl-editable-area .content="${this.content?.contentElements}"></mgnl-editable-area>
                    </mb-e-banking-tab-item>
                `,
                html`<h3 class="mb-0 text-base font-medium py-24 text-green-medium">${this.content.title}</h3>
                    <mgnl-editable-area .content="${this.content?.contentElements}"></mgnl-editable-area> `,
            )}
        `;
    }
}

defineElement('editable-tab-item', EditableTabItem);
